module.exports = "query Showrooms($sku:String!,$locale:Locale!){data:articles(skus:[$sku],locale:$locale){inShowrooms{url name image}}}"